<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/dashboard">
      <!--<CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />-->
      <CImg 
        class="c-sidebar-brand-minimized" 
        src="./img/logos/logo-azul-texto.png"
        height="64"
      />

      <CImg 
        class="c-sidebar-brand-full" 
        src="./img/logos/logo-azul-texto.png"
        height="64"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$store.state.menu"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import axios from 'axios'
export default {
  name: 'TheSidebar',
  data() {
    return {
      menu: [],
      buffer: []
    }
  },

  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  mounted () {
    let self = this
    if (self.$store.state.menu.length === 0)
    {
      self.$http.get('/api/menu').then((response) => {
        this.$store.commit('set', ['menu', self.buildData(response.data)])
        //self.menu = self.buildData(response.data)
      })
    }
  },
  methods: {
    buildData(data) {
      this.buffer = [{
        _name: 'CSidebarNav',
        _children: []
      }]

      for(let i = 0; i < data.menu.length; i++)
      {
        if (data.menu[i].href.indexOf('http') !== -1)
        {
          this.buffer[0]._children.push({
            _name: 'CSidebarNavItem',
            name: data.menu[i].name,
            href: data.menu[i].href,
            icon: data.menu[i].icon,
            target: '_blank'
          })
        } else {
          this.buffer[0]._children.push({
            _name: 'CSidebarNavItem',
            name: data.menu[i].name,
            to:   data.menu[i].href,
            icon: data.menu[i].icon,
          })
        }
      }
      return this.buffer
    },
  }
}
</script>
